(function() {
  angular
    .module('cfn')
    .factory('stockyardCoreDataResolver', stockyardCoreDataResolver);

  stockyardCoreDataResolver.$inject = ['Stockyard'];

  // resolve function bef
  function stockyardCoreDataResolver(Stockyard) {
    return function() {
      return coreCommonResolveFunction(Stockyard);
    };
  }
})();
